import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { useAuth } from "../lib/auth";
import { api, apiError } from "../lib/api";
import { formatARS, PHONE, WHATSAPP_NUMBER } from "../lib/site";

const Row = ({ k, v }) => (v ? <><dt className="text-black/60">{k}</dt><dd className="font-semibold">{v}</dd></> : null);
const unit = (j) => (j.module === "cargas" ? (j.trailer_id ? "Camión con semirremolque" : "Camión") : "Ómnibus de turismo");
const today = () => new Date().toLocaleDateString("es-AR", { timeZone: "America/Argentina/Buenos_Aires" });

export default function AdminPresupuesto() {
  const { id } = useParams();
  const { user } = useAuth();
  const [j, setJ] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { if (user?.role === "admin") api.get(`/fleet/jobs/${id}`).then((r) => setJ(r.data)).catch((e) => setErr(apiError(e))); }, [user, id]);

  if (user === null) return <div className="grid min-h-[60vh] place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin" replace />;
  if (err) return <p data-testid="quote-error" className="p-10 text-red-700">{err}</p>;
  if (!j) return <div className="grid min-h-[60vh] place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  const load = j.module === "cargas" ? (j.weight_kg ? `${Number(j.weight_kg).toLocaleString("es-AR")} kg` : "") : (j.passengers ? `${j.passengers} pasajeros` : "");

  return (
    <section data-testid="quote-page" className="mx-auto max-w-2xl space-y-6 px-5 py-10 print:max-w-none print:p-0">
      <button onClick={() => window.print()} data-testid="quote-print" className="inline-flex items-center gap-2 rounded-full bg-[var(--forest)] px-5 py-2.5 text-sm font-bold text-white print:hidden"><Printer className="h-4 w-4" /> Imprimir o guardar PDF</button>
      <div className="rounded-3xl border-2 border-black/40 bg-white p-6 text-black print:rounded-none print:border-0 md:p-8">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <img src="/brand/logo-green.png" alt="Santiagueño" className="h-10 w-auto" />
          <div className="text-right text-xs"><p className="font-bold uppercase">Presupuesto {j.module === "cargas" ? "de carga" : "de turismo"}</p><p data-testid="quote-code" className="font-mono text-sm">Nº {j.code}</p><p>Emitido {today()}</p></div>
        </div>
        <dl className="mt-6 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
          <Row k="Cliente" v={j.client} />
          <Row k="Contacto" v={[j.client_phone, j.client_email].filter(Boolean).join(" · ")} />
          <Row k="Recorrido" v={`${j.origin} → ${j.destination}`} />
          <Row k="Fecha" v={`${j.date}${j.return_date ? ` al ${j.return_date}` : ""}`} />
          <Row k="Unidad" v={unit(j)} />
          <Row k="Detalle" v={j.detail} />
          <Row k={j.module === "cargas" ? "Carga" : "Grupo"} v={load} />
          <Row k="Kilómetros" v={`${Number(j.km).toLocaleString("es-AR")} km`} />
        </dl>
        <div className="mt-6 flex flex-wrap items-baseline justify-between gap-2 rounded-2xl bg-[var(--ink)] p-5 text-white print:bg-black">
          <span className="text-sm">Precio total</span>
          <span data-testid="quote-price" className="text-3xl font-bold text-[var(--lime)]">{formatARS(j.price)} <span className="text-sm font-normal text-white">+ impuestos</span></span>
        </div>
        <p className="mt-4 text-xs">Presupuesto válido por {j.valid_days} días desde su emisión.</p>
        <p className="mt-1 text-xs">Contacto: Tel. {PHONE} · WhatsApp {WHATSAPP_NUMBER}</p>
        <div className="mt-10 grid grid-cols-2 gap-6 text-center text-xs"><div><div className="border-t border-black" /><p className="mt-1">Conformidad del cliente</p></div><div><div className="border-t border-black" /><p className="mt-1">Santiagueño</p></div></div>
      </div>
    </section>
  );
}
